<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Chapters</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row justify="center" align="center">
        <v-col cols="12" sm="4" md="4">
          <v-autocomplete rounded color="#0F2027" :items="std_list" v-model="std" item-text="name" return-object
            label="Standard" dense outlined placeholder="Select Standard" @change="getCourses()"></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-autocomplete rounded color="#0F2027" :items="courses_list" v-model="course" item-text="course"
            return-object label="Course" :disabled="std == null" dense outlined placeholder="Select Course"
            @change="getChapters()"></v-autocomplete>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="box" v-if="course != null">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>{{ std.name }} : {{ course.course }}</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-data-table :headers="headers" :items="chapter_list" class="elevation-1 mytable" dense :search="search">
        <template v-slot:top>
          <v-toolbar flat dense color="white">
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="button" v-on="on">Add Chapter</v-btn>
              </template>
              <v-card>
                <v-card-title class="toolbar">
                  <span class="headline">Chapter</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="std.name" color="#0F2027" dense disabled rounded outlined persistent-hint
                          hint="Standard" label="Selected Standard"></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="course.course" color="#0F2027" dense disabled rounded outlined
                          persistent-hint hint="Course" label="Selected Course"></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="chapter" color="#0F2027" dense rounded outlined persistent-hint
                          hint="Chapter Name" label="Chapter Name"></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <v-checkbox dense v-model="isactive" color="success" label="Active"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="button" @click="close">Cancel</v-btn>
                  <v-btn class="button" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  /*
      Defines the data used by the component
    */
  data() {
    return {
      load: false,
      // extraBreadcrumbItems: [
      //   { text: "Chapter Master", disabled: true, href: "" },

      // ],
      // breadcrumbClass: "breadcrumb-style1",

      loading3: false,
      search: "",
      snackbar: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      std_list: [],
      courses_list: [],
      chapter_list: [],
      std: null,
      course: null,
      chapter: null,
      id: null,
      isactive: false,
      dialog: false,
      editedIndex: -1,
      headers: [
        { text: "Chapter Name", value: "chapter" },
        { text: "Active", value: "isactive" },
        { text: "Action", value: "action" },
      ],
      output_load: false,
    };
  },

  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    getCourses() {
      this.chapter_list = [];
      this.course = null;
      const formData = {
        std_id: this.std.id,
      };
      axios
        .post("/QuizQuestionBank/getStandardCourse", formData)
        .then((res) => {
          this.courses_list = res.data.courses_list;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
    getChapters() {
      const formData = {
        crs_id: this.course.c_id,
      };
      axios
        .post("/QuizQuestionBank/chapter", formData)
        .then((res) => {
          this.chapter_list = res.data.chapter_list;
          if (this.chapter_list.length == 0) {
            this.showSnackbar("#b71c1c", "Chapters not added yet!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
    editItem(item) {
      this.editedIndex = this.chapter_list.indexOf(item);
      this.id = item.id,
        this.chapter = item.chapter,
        this.isactive = item.isactive,
        this.dialog = true;
    },
    save() {
      if (this.editedIndex == -1) {
        const formData = {
          crs_id: this.course.c_id,
          chapter_name: this.chapter,
          isactive: this.isactive,
        };
        axios
          .post("/QuizQuestionBank/saveChapter", formData)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.showSnackbar("#4caf50", "Chapter added successfully...");
            } else {
              this.showSnackbar("#b71c1c", "Chapter already present!!!");
            }
            this.getChapters();
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          })
          .finally(() => {});
        this.close();
      } else {
        
        const formData = {
          chapter_id: this.id,
          chapter_name: this.chapter,
          isactive: this.isactive,
          crs_id: this.course.c_id,
        };
        axios
          .post("/QuizQuestionBank/editChapter", formData)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.showSnackbar("#4caf50", "Chapter updated successfully...");
            } else {
              this.showSnackbar("#b71c1c", "Chapter already present!!!");
            }
            this.getChapters();
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          })
          .finally(() => {});
        this.close();
      }
    },
    // saveEditedData(){
    //     const formData = {
    //     chapter_id: item.id,
    //     chapter_name: item.chapter,
    //     isactive: item.isactive,
    //   };
    //     axios
    //   .post("/QuizQuestionBank/editChapter", formData)
    //   .then((res) => {
    //     if (res.data.flag == "YES") {
    //         this.showSnackbar("#4caf50", "Chapter updated successfully...");
    //     }else{
    //         this.showSnackbar("#b71c1c", "Chapter already present!!!");
    //     }
    //     this.getChapters()
    //   })
    //   .catch((error) => {
    //     this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
    //   })
    //   .finally(() => {});
    //     this.close()

    // },
    close() {
      this.dialog = false;
      this.dialog_edit = false;
      this.chapter = null;
      this.isactive = false;
      this.id = null;
    },
  },
  mounted() {
    axios
      .post("/InstallmentStructureDetails/importLearnerSelectionHome")
      .then((res) => {
        this.std_list = res.data.std_list;
      })
      .catch((error) => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
      })
      .finally(() => {});
  },
};
</script>
<style scoped>
.downbtn {
  float: right;
}
.mytable /deep/ thead th {
  background: #0f2027; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
